<template>
    <el-card>
        <div slot="header" class="move">
            <h3>Average Net Income Per Deal</h3>
        </div>

        <div class="radial-guage-container text-center px-5">
            <radial-gauge :ref="gaugeRef" :value="value" :options="options"
                          class="radial-guage-component w-100 h-auto"></radial-gauge>
        </div>

        <div class="row dash-avg-stats-container">
            <div class="col-md-8 offset-md-2">
                <div class="d-flex">
                    <div class="card-body px-3 py-2 d-flex flex-column">
                        <div class="d-flex flex-row align-items-center">
                            <span class="card-value"><h2>${{ animatedAvgIncome }}</h2></span>
                            <span class="card-change"></span>
                        </div>
                        <small class="dashboard-stats-label">Average Net Commission ex GST</small>
                    </div>
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
import RadialGauge from 'vue2-canvas-gauges/src/RadialGauge'

export default {
    name: 'AverageIncomeChart',
    components: {
        RadialGauge
    },
    props: [
        'appearance',
        'tenantId',
        'dashboardId'
    ],
    data() {
        return {
            averageIncomeData: [],
            gaugeRef: "AVGGauge",
            value: 0,
            options: {
                animateOnInit: false,
                animatedValue: false,
                fontNumbers: "Poppins",
                fontUnits: "Poppins",
                fontTitle: "Poppins",
                fontValue: "Poppins",
                fontValueSize: 13,
                fontNumbersSize: 13,
                fontNumbersWeight: "bold",
                fontUnitsSize: 13,
                title: "Ambition Cloud",
                fontTitleSize: 14,
                colorTitle: '#000',
                colorBarProgress: "rgba(50,200,50,.75)",
                barWidth: 10,
                barShadow: 5,
                ticksWidth: 6,
                ticksWidthMinor: 2,

                width: 600,
                height: 600,
                units: "",
                minValue: 0,
                startAngle: 90,
                ticksAngle: 180,
                valueBox: true,
                maxValue: 3000,
                minorTicks: 5,
                strokeTicks: true,
                highlightsWidth: 10,
                highlights: [
                    {
                        "from": 2500,
                        "to": 3000,
                        "color": "rgba(200, 50, 50, .75)"
                    }
                ],
                colorPlate: "#fff",
                borderShadowWidth: 0,
                borders: false,
                needleType: "arrow",
                needleWidth: 2,
                needleCircleSize: 7,
                needleCircleOuter: true,
                needleCircleInner: true,
                animationDuration: 1500,
                animationRule: "linear"
            },
            metrics: {
                current_avg_income: 0,
                overall_avg_income: 0
            }
        }
    },
    mounted() {
        document.fonts && document.fonts.forEach(function (font) {
            font.loaded.then(function () {
                if (font.family.match(/Led/)) {
                    document.gauges.forEach(function (gauge) {
                        gauge.update()
                    })
                }
            })
        })

        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.averageIncomeData = event.avgIncome.averageIncome

            let tempMax = this.averageIncomeData.longAvg * 1.2
            let tempIncrement = parseFloat(Number(tempMax / 250 / 5).toFixed(1)) * 250
            tempMax = tempIncrement * 5

            if (tempMax != this.options.maxValue) {
                this.options.maxValue = tempMax
                this.options.highlights[0].from = this.averageIncomeData.longAvg
                this.options.highlights[0].to = tempMax
                this.options.majorTicks = [
                    "$0",
                    "$" + tempIncrement * 1,
                    "$" + tempIncrement * 2,
                    "$" + tempIncrement * 3,
                    "$" + tempIncrement * 4,
                    "$" + tempIncrement * 5,
                ];
                this.$refs.AVGGauge.chart.options = Object.assign(this.$refs.AVGGauge.chart.options, this.options)
                this.$refs.AVGGauge.chart.update()
            }

            this.value = this.averageIncomeData.shortAvg
            this.graphColorChange()
            this.graphBGColorChange()
        })
    },
    created() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.averageIncomeData = event.avgIncome.averageIncome

            let tempMax = this.averageIncomeData.longAvg * 1.2
            let tempIncrement = parseFloat(Number(tempMax / 250 / 5).toFixed(1)) * 250
            tempMax = tempIncrement * 5

            if (tempMax != this.options.maxValue) {
                this.options.maxValue = tempMax
                this.options.highlights[0].from = this.averageIncomeData.longAvg
                this.options.highlights[0].to = tempMax
                this.options.majorTicks = [
                    "$0",
                    "$" + tempIncrement * 1,
                    "$" + tempIncrement * 2,
                    "$" + tempIncrement * 3,
                    "$" + tempIncrement * 4,
                    "$" + tempIncrement * 5,
                ];
                this.$refs.AVGGauge.chart.options = Object.assign(this.$refs.AVGGauge.chart.options, this.options)
                this.$refs.AVGGauge.chart.update()
            }

            this.value = this.averageIncomeData.shortAvg

            this.graphColorChange()
            this.graphBGColorChange()
        })
    },
    watch: {
        "value": function (newValue) {
            TweenLite.TweenLite.to(this.$data.metrics, 1.5, {
                current_avg_income: newValue
            });
        },
    },
    computed: {
        animatedAvgIncome: function () {
            return this.metrics.current_avg_income.toFixed(0)
        }
    },
    destroyed() {
        Echo.leave(`dashboard.${this.tenantId}.${this.dashboard}`)
    },
    methods: {
        graphBGColorChange() {
            return this.appearance == "white" ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255,255,255, 0.9)'
        },
        graphColorChange() {
            return this.appearance == 'black' ? "#fff" : "#000"
        },
        commarize(val, min) {
            min = min || 1e3;

            let isNeg = val < 0;
            let posNum = Math.abs(val);

            // Alter numbers larger than 1k
            if (posNum >= min) {
                var units = ["k", "M", "B", "T"];

                var order = Math.floor(Math.log(posNum) / Math.log(1000));

                var unitname = units[(order - 1)];
                var num = Math.floor(posNum / 1000 ** order);

                if (String(num).length == 1) {
                    num = Number(posNum / 1000 ** order).toFixed(1);
                    if (num == Number(num)) {
                        num = Number(num);
                    }
                }

                if (isNeg)
                    num = 0 - Number(num);

                return num + unitname;
            }

            if (isNeg)
                posNum = 0 - posNum;

            val = posNum;

            return val.toLocaleString();
        }
    }
}
</script>

<style lang="scss" scoped>
.radial-guage-container {
    overflow: hidden;
    max-width: 450px;
    margin: 0 auto;

    .canvas-gauges.radial-guage-component {
        margin-bottom: calc(-40%);
    }
}

.dash-avg-stats-container {
    .card-body {
        text-align: center !important;
    }

    .card-value {
        margin-left: auto !important;
        margin-right: auto !important;
    }
}
</style>

<style lang="scss">
.dash-avg-stats-container {
    .card-body {
        text-align: center !important;
    }

    .card-value {
        margin-left: auto !important;
        margin-right: auto !important;
    }
}
</style>
